export const LOADING_UPDATE = 'LOADING_UPDATE'
